import React, { useState, useEffect, useContext } from 'react';
import useQueries from '../../../database/useQueries';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { GlobalContext } from '../../../App';
import FormTemplate from '../../template/form/FormTemplate';
import LoadingOverlay from '../pagesMains/LoadingOverlay';
import { DataContext, TemplateContext } from '../pagesMains/GravesManagers/Graves';
import { v4 as uuidv4 } from 'uuid';
import { addRecordToCache, createFetchDataServer, createFetchDataServerWithCallback, getTableData } from '../../../database/fetchData';

const NAME_ENTITY = 'בית עלמין';

function CemeteryCreate() {
  // קבלת ערכים מהסטור
  const columns = useSelector((state) => state.columnsFormCemeteries.data);

  const { setTotalWidthContainer } = useContext(TemplateContext);
  const { setTitle } = useContext(GlobalContext);

  const context = useContext(DataContext);
  const fetchDataServer = createFetchDataServer(context);

  const [loading, setLoading] = useState(true); // מצב טעינה

  // טעינת היוזים לפונקציות עזר
  const { addOrUpdateDataCemetery } = useQueries();

  // ערכי הראוטר
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    setTotalWidthContainer(1200);
    setTitle(`הוספת בית עלמין`);
  }, [location.pathname]);

  // איזור המשתנים והסטייטים
   const [formValues, setFormValues] = useState({}); // ערכי השדות
  const [errors, setErrors] = useState({}); // שגיאת השדות
  // עוקב אחר שליחת נתונים לשרת דרך פונקציית סבמיט
  const [loadingData, setLoadingData] = useState(false);

  const handleChange = (event) => {
    setFormValues({ ...formValues, [event.target.name]: event.target.value });
  };

  const validateForm = () => {
    let tempErrors = {};
    let formIsValid = true;

    columns.forEach((field) => {
      if (field?.required && !formValues[field.name]) {
        tempErrors[field.name] = 'שדה חובה';
        formIsValid = false;
      }
      if (field.notRepeat && formValues[field.name]) {
        if (context?.contextCemeteries.some((item) => item[field.name] === formValues[field.name])) {
          tempErrors[field.name] = `הערך ${formValues[field.name]} כבר קיים`;
          formIsValid = false;
        }
      }
    });

    setErrors(tempErrors);
    return formIsValid;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (validateForm()) {

      let updatedFormValues = { ...formValues };

      setLoadingData(true);

      const unicId = uuidv4()

      // שליחה לשרת עם הערך החדש
      let res = await addOrUpdateDataCemetery(formValues, unicId);
      if (res === 200) {
        context?.setContextCemeteries((prev) => {
          updatedFormValues = { ...updatedFormValues, id: unicId, unicId: unicId,
            availableSum: 0, purchasedSum: 0, buriedSum: 0, savedSum: 0, graveSum: 0 };

          // בדיקה אם הערך קיים בסטייט
          const existingIndex = prev.findIndex((item) => item.unicId === updatedFormValues.unicId);

          addRecordToCache(updatedFormValues, 'dataCemeteries');


          if (existingIndex !== -1) {
            // אם הערך קיים, מעדכן אותו
            const updatedState = [...prev];
            updatedState[existingIndex] = { ...updatedState[existingIndex], ...updatedFormValues };
            return updatedState;
          } else {
            // אם הערך לא קיים, מוסיף אותו
            return [...prev, updatedFormValues];
          }
        });
        setLoadingData(false);
        navigate(-1);
      }
    }
  };

  useEffect(() => {
    async function loadTableData() {
      const localTempData = await getTableData('myDatabase', 'myStore');
      if (localTempData) {
        const dataCemeteries = localTempData.find((item) => item.name === 'dataCemeteries');
        if (dataCemeteries) {
          setLoading(false);
        }
      }
      else {
        const handlePartialUpdate = (tableName) => {
          console.log(`Partial update received for table: ${tableName}`);
          setLoading(false);
        };
        // fetchDataServerWithCallback(['cemeteries'], token, handlePartialUpdate);
      }
    }
    loadTableData();
  }, []);

  if (loading || loadingData) return <LoadingOverlay />;

  return (
    <>
      <FormTemplate title={`הוספת ${NAME_ENTITY}`} btn={`שמור`} fields={columns} columns={columns} formValues={formValues} handleChange={handleChange} handleSubmit={handleSubmit} errors={errors} />
    </>
  );
}

export default CemeteryCreate;
